import { CircleButton } from 'component/Button/CircleButton'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Dots } from 'page/catalog/ItemPreview/Dots'
import { demo } from 'page/catalog/store/CatalogStore'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { getShortcut } from 'util/keyboard'
import css from './MainImage.module.scss'

export const MainImage = observer(() => {
  const { ratio } = demo.it.product
  const store = itemPreview.it
  const { current, len, images } = store
  const image = images[current]
  const many = len > 1
  const left = current > 0
  const right = current < len - 1

  useEffectOnce(() => {
    const listener = (event: KeyboardEvent) => {
      const shortcut = getShortcut(event)
      if (shortcut === 'ArrowLeft') --store.current
      if (shortcut === 'ArrowRight') ++store.current
    }

    window.addEventListener('keydown', listener)
    return () => window.removeEventListener('keydown', listener)
  })

  const onLeft = useLatestCallback(() => {
    --store.current
  })

  const onRight = useLatestCallback(() => {
    ++store.current
  })

  return <Space className={css.root} ratio={ratio} center>
    {image && <Image src={image} />}
    {many && <Space className={css.left}>
      <CircleButton clear disabled={!left} onClick={onLeft}>
        <Icon size={20} name="keyboard_arrow_left" />
      </CircleButton>
    </Space>}
    {many && <Space className={css.right}>
      <CircleButton clear disabled={!right} onClick={onRight}>
        <Icon size={20} name="keyboard_arrow_right" />
      </CircleButton>
    </Space>}
    {many && <Space pin={[null, null, 16, 16]}>
      <Dots />
    </Space>}
  </Space>
})
